import i18next from 'i18next';

i18next.addResources('es_CL', 'NPSFormButtonSubmit', {
  sendOpinion: 'Enviar opinión'
});
